import { ReactNode } from 'react';

import classNames from 'classnames';

type TProps = {
    isOpen: boolean;
    children: ReactNode;
};

/**
 * Плавно сворачиваемая область неизвестной высоты: анимируется
 * `grid-template-rows` 1fr ⇄ 0fr, поэтому высоту заранее знать не нужно.
 */
export const CollapsibleArea = ({ isOpen, children }: TProps) => (
    <div  className={classNames('collapsible-area', { 'collapsible-area--closed': !isOpen })}>
        <div className="collapsible-area__inner">{children}</div>
    </div>
);
